module.exports = __webpack_public_path__ + "album_bgc.png?d06418f65c64cffbc3bbb73f2997e04d";